import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

export const initializeCapacitor = async () => {
  if (Capacitor.isNativePlatform()) {
    try {
      const platform = Capacitor.getPlatform();
      
      // iOS: overlay false to calculate safe areas BEFORE render
      // Android: overlay true for normal behavior
      await StatusBar.setOverlaysWebView({ 
        overlay: platform === 'android' 
      });
      
      // Set status bar style based on platform
      if (platform === 'ios') {
        await StatusBar.setStyle({ style: Style.Dark });
      } else {
        await StatusBar.setStyle({ style: Style.Light });
      }
      
      // Wait for safe area CSS variables to be available
      setTimeout(() => {
        const computedStyle = getComputedStyle(document.documentElement);
        console.log('📱 Safe Area CSS Variables:', {
          top: computedStyle.getPropertyValue('--safe-area-inset-top'),
          bottom: computedStyle.getPropertyValue('--safe-area-inset-bottom'),
          actualTop: window.getComputedStyle(document.documentElement).getPropertyValue('env(safe-area-inset-top)') || '0px',
          actualBottom: window.getComputedStyle(document.documentElement).getPropertyValue('env(safe-area-inset-bottom)') || '0px'
        });
      }, 200);
      
      console.log(`✅ Capacitor initialized (${platform}, overlay: ${platform === 'android'})`);
    } catch (error) {
      console.error('❌ Error initializing Capacitor:', error);
    }
  }
};